var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHelihoistLightWithSroL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 473,
    height: 474,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1741,
    y: 1229,
    width: 473,
    height: 474
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-1741 -1229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1775 1466 1977.5 1263 2180 1466 1977.5 1669Z",
    stroke: "#000000",
    strokeWidth: 48.125,
    strokeMiterlimit: 8,
    fill: "#81F248",
    fillRule: "evenodd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelihoistLightWithSroL);
export default __webpack_public_path__ + "static/media/HelihoistLightWithSroL.82b2fe30e1799d56e3bfd5dbcd090366.svg";
export { ForwardRef as ReactComponent };